import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputCheckbox from '../../commons/form/InputCheckBox'
import FinancingTypeProductModalPage from '../../../containers/masters/FinancingTypeProduct/FinancingTypeProductModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class FinancingTypeProductMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        name: null,
        description: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchFinancingTypeProductList(null)
    this.props.actions.fetchFinancingTypeProductFields()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFinancingTypeProductList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchFinancingTypeProductList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (value) {
    this.setState({ filter: { ...this.state.filter, name: value } })
  }

  handleDescriptionChange (value) {
    this.setState({ filter: { ...this.state.filter, description: value } })
  }

  searchFinancingTypeProductList () {
    this.props.actions.fetchFinancingTypeProductList({ ...this.props.filter, ...this.state.filter })
  }

  resetFilters () {
    this.setState({
      filter: {
        name: null,
        description: null
      }
    }, () => { this.searchFinancingTypeProductList() })
  }

  render () {
    const {
      t, financingTypeProductList, pagesCount, financingCount, filter, fields,
      filter: { page },
      actions: { deleteFinancingTypeProduct, openFinancingTypeProductModal, recoverFinancingTypeProduct, fetchFinancingTypeProductList }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'financingTypeProductPage' })
    const tKey = 'MASTERS.FINANCING_TYPE_PRODUCT.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.description || this.state.filter.name)

    return (
      <div id='financingTypeProductMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openFinancingTypeProductModal(null)}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="filters.name"
                name="filters.name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                id="filters.description"
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchFinancingTypeProductList()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}NAME`)}
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th onClick={() => { this.changeOrder('description') }}>
                      {t(`${tKey}DESCRIPTION`)}
                      <i className={this.getSortIcon('description')} />
                    </th>
                    <th onClick={() => { this.changeOrder('reactivatable') }}>
                      {t(`${tKey}REACTIVATABLE`)}
                      <i className={this.getSortIcon('reactivatable')} />
                    </th>
                    <th onClick={() => { this.changeOrder('repurchase') }}>
                      {t(`${tKey}REPURCHASE`)}
                      <i className={this.getSortIcon('repurchase')} />
                    </th>
                    {fields && fields.map((financingField, idx) => (
                      <th key={'field_' + idx}>
                        {('0' + (idx + 1)).slice(-2)}
                      </th>
                    ))}
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {financingTypeProductList && financingTypeProductList.map((financingTypeMaster, idx) => (
                    <tr key={idx} className={financingTypeMaster.isDeleted ? 'is-deleted' : ''}>
                      <td>{financingTypeMaster.name}</td>
                      <td>{financingTypeMaster.description}</td>
                      <td>{
                        <Field
                          component={InputCheckbox}
                          name={'selectedCheck_' + financingTypeMaster.financingTypeProductId}
                          checked = {financingTypeMaster.reactivatable}
                          disabled= {true}
                          id={'selectedCheck_' + financingTypeMaster.financingTypeProductId}
                        />}
                      </td>
                      <td>
                        { <Field
                          component={InputCheckbox}
                          name={'selectedCheck_rep' + financingTypeMaster.financingTypeProductId}
                          checked = {financingTypeMaster.repurchaseAgreement}
                          disabled= {true}
                          id={'selectedCheck_rep' + financingTypeMaster.financingTypeProductId}
                        />}
                      </td>
                      {fields && fields.map((financingField, idx) => (
                        <td key={'tdfield_' + idx}>
                          {
                            <Field
                              component={InputCheckbox}
                              name={'selectedCheck_rep_field' + financingTypeMaster.financingTypeProductId + financingField.financingFieldsProductId}
                              checked = {financingTypeMaster.fields[financingField.financingFieldsProductId] ? financingTypeMaster.fields[financingField.financingFieldsProductId] : false}
                              disabled= {true}
                              id={'selectedCheck_rep_field' + financingTypeMaster.financingTypeProductId + financingField.financingFieldsProductId}
                            />
                          }
                        </td>
                      ))}
                      <td className='actions'>
                        {!financingTypeMaster.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openFinancingTypeProductModal(financingTypeMaster.financingTypeProductId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteFinancingTypeProduct(financingTypeMaster.financingTypeProductId)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <div>
                            <OverlayTrigger placement="left" overlay={recoverTooltip}>
                              <a className='_Btn accent stk o-icn ' onClick={() => recoverFinancingTypeProduct(financingTypeMaster.financingTypeProductId)}>
                                <i className='iDocIcon-undo-back' />
                              </a>
                            </OverlayTrigger>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                  {(financingTypeProductList === null || financingTypeProductList === undefined || financingTypeProductList.length === 0) &&
            <tr>
              <td colSpan={5 + (fields ? fields.length : 0) }><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}

                </tbody>
              </Table>
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_finance"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={financingCount}
                    onSelectAction={(value) => fetchFinancingTypeProductList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        <FinancingTypeProductModalPage/>

        <Col sm={12} className="col-row  section-users-body">

        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'financingTypeProductMaster'
})(FinancingTypeProductMaster)
